import React from 'react';
import { cx } from '@emotion/css';
import { useSwitchStyles } from './Switch.styles';
function SwitchUncheckIcon() {
    const classes = useSwitchStyles();
    return (React.createElement("div", { className: cx('MuiSwitch-thumb', classes.iconWrapper) },
        React.createElement("i", { className: cx('material-icons', classes.icon) }, "clear")));
}
export default React.memo(SwitchUncheckIcon);
//# sourceMappingURL=SwitchUncheckIcon.js.map